/*
  Estimated delivery, worked out in the browser on New York time.
  snippets/ri-estimate-delivery.liquid prints the same range on the server, but Shopify can serve a cached
  page from an earlier day or from before the 3 PM cutoff, so the dates are redone here from the
  block's data attributes with the same rules: business days, the cutoff, and USPS holidays.
  A variant change redraws the block from the server, so each wrapper is watched and redone after it.
*/
(function () {
  'use strict';

  var ZONE = 'America/New_York';
  var FIXED_HOLIDAYS = ['01-01', '06-19', '07-04', '11-11', '12-25'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function nowInStore() {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: ZONE,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hourCycle: 'h23',
    })
      .formatToParts(new Date())
      .forEach(function (p) {
        parts[p.type] = Number(p.value);
      });
    return parts;
  }

  /* USPS: fixed holidays (a Saturday one is observed Friday, a Sunday one Monday) and the Monday/Thursday ones. */
  function isHoliday(d) {
    var dow = d.getUTCDay();
    var mon = d.getUTCMonth() + 1;
    var dom = d.getUTCDate();
    var nth = Math.floor((dom - 1) / 7) + 1;
    var md = function (date) {
      return pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());
    };
    var prev = new Date(d.getTime() - 86400000);
    var next = new Date(d.getTime() + 86400000);
    if (FIXED_HOLIDAYS.indexOf(md(d)) !== -1) return true;
    if (dow === 1 && FIXED_HOLIDAYS.indexOf(md(prev)) !== -1) return true;
    if (dow === 5 && FIXED_HOLIDAYS.indexOf(md(next)) !== -1) return true;
    if (dow === 1 && mon === 1 && nth === 3) return true;
    if (dow === 1 && mon === 2 && nth === 3) return true;
    if (dow === 1 && mon === 5 && dom >= 25) return true;
    if (dow === 1 && mon === 9 && nth === 1) return true;
    if (dow === 1 && mon === 10 && nth === 2) return true;
    if (dow === 4 && mon === 11 && nth === 4) return true;
    return false;
  }

  function range(minTarget, maxTarget, cutoff, skipWeekends) {
    var now = nowInStore();
    if (now.hour >= cutoff) {
      if (minTarget > 0) minTarget += 1;
      if (maxTarget > 0) maxTarget += 1;
    }
    var minDay = null;
    var maxDay = null;
    var biz = 0;
    for (var i = 1; i <= 45; i++) {
      var d = new Date(Date.UTC(now.year, now.month - 1, now.day + i));
      var dow = d.getUTCDay();
      if (skipWeekends && (dow === 0 || dow === 6)) continue;
      if (isHoliday(d)) continue;
      biz += 1;
      if (biz === minTarget && !minDay) minDay = d;
      if (biz === maxTarget && !maxDay) {
        maxDay = d;
        break;
      }
    }
    return minDay && maxDay ? [minDay, maxDay] : null;
  }

  function setDate(span, d) {
    if (!span) return;
    var long = span.querySelector('.ri-ed-date--long');
    var short = span.querySelector('.ri-ed-date--short');
    var month = MONTHS[d.getUTCMonth()];
    var day = pad(d.getUTCDate());
    if (long) long.textContent = month + ' ' + day;
    if (short) short.textContent = month.slice(0, 3) + ' ' + day;
  }

  function refresh(box) {
    if (!box || !box.dataset) return;
    var r = range(
      Number(box.dataset.riEdMin) || 0,
      Number(box.dataset.riEdMax) || 0,
      Number(box.dataset.riEdCutoff) || 15,
      box.dataset.riEdSkipWeekends !== 'false'
    );
    if (!r) return;
    var slots = box.querySelectorAll('[data-ri-ed-slot]');
    setDate(slots[0], r[0]);
    setDate(slots[1], r[1]);
  }

  function refreshIn(root) {
    root.querySelectorAll('.ri-estimate-delivery[data-ri-ed-min]').forEach(refresh);
  }

  function init() {
    if (typeof Intl === 'undefined' || !Intl.DateTimeFormat.prototype.formatToParts) return;
    refreshIn(document);
    document.querySelectorAll('[id^="RiDelivery-"]').forEach(function (wrap) {
      new MutationObserver(function () {
        refreshIn(wrap);
      }).observe(wrap, { childList: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
